import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { IoFlag } from 'react-icons/io5';
import i18next from 'i18next';
import { enabledStates } from '../../config/states';
import './StateFlagsNav.css';

const StateFlagsNav = () => {
  const { state: currentState } = useParams();
  const states = enabledStates().filter((s) => s.flag);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (e.target.closest('.state-flags-nav')) return;
      setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [currentState]);

  if (!states.length) return null;

  // Only one state: the flag trigger is a direct link to its seat list, no menu.
  if (states.length === 1) {
    const s = states[0];
    const label = i18next.t(s.nameKey);
    const seatHint = i18next.t('议席列表');
    return (
      <nav className="state-flags-nav" aria-label="State navigation">
        <Link
          to={`/seats/${s.slug}/n`}
          className="state-flags-nav__trigger is-active"
          aria-label={label}
          title={label}
        >
          <img src={s.flag} alt={label} />
        </Link>
        <Link
          to={`/seats/${s.slug}/n`}
          className="state-flags-nav__hint"
          aria-hidden="true"
          tabIndex={-1}
        >
          {seatHint}
        </Link>
      </nav>
    );
  }

  const activeState = states.find((s) => s.slug === currentState);
  const menuStates = activeState
    ? states.filter((s) => s.slug !== activeState.slug)
    : states;
  const triggerLabel = activeState ? i18next.t(activeState.nameKey) : '选择州属';

  return (
    <nav
      className={`state-flags-nav ${open ? 'is-open' : ''}`}
      aria-label="State navigation"
    >
      <ul className="state-flags-nav__menu" aria-hidden={!open}>
        {menuStates.map((s, i) => {
          const label = i18next.t(s.nameKey);
          return (
            <li
              key={s.slug}
              className="state-flags-nav__item"
              style={{ '--i': i + 1 }}
            >
              <Link
                to={`/seats/${s.slug}/n`}
                className="state-flags-nav__btn"
                aria-label={label}
                title={label}
                tabIndex={open ? 0 : -1}
                onClick={() => setOpen(false)}
              >
                <img src={s.flag} alt={label} />
              </Link>
            </li>
          );
        })}
      </ul>

      <button
        type="button"
        className={`state-flags-nav__trigger${activeState ? ' is-active' : ''}${open ? ' is-open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? '收起州属选单' : triggerLabel}
        aria-expanded={open}
        title={triggerLabel}
      >
        {activeState ? (
          <img src={activeState.flag} alt={triggerLabel} />
        ) : (
          <IoFlag aria-hidden="true" />
        )}
      </button>
    </nav>
  );
};

export default StateFlagsNav;
